import PropTypes from "prop-types";
import React from "react";

import AddDestinationForm from "v2/components/responsive/AddDestinationForm";
import ModalLink from "v2/components/responsive/ModalLink";

const AddDestinationLink = (props, context) => {
  const {params: {date, routeId}} = context;
  return (
    <ModalLink
      form={AddDestinationForm}
      label="New Destination"
      url={`/${date}/${routeId}/new`}
      {...props} />
  );
};

AddDestinationLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
};

export default AddDestinationLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/AddDestinationLink.js
 **/